import { Route, Routes } from "react-router-dom";
import { Extracao } from "./list";

export default function ExtracaoRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Extracao />} />
    </Routes>
  );
}
